import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  fileUploaderChip: {
    backgroundColor: 'transparent',
    color: theme.vars.palette.primary.light,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.vars.palette.text.primary
    },
    '&:focus': {
      backgroundColor: 'transparent',
      color: theme.vars.palette.text.primary
    }
  },
  fileUploaderDeleteIcon: {
    color: theme.vars.palette.common.white,
    '&:hover': {
      color: theme.vars.palette.text.primary_a75
    }
  },
  fileUploaderFileInput: {
    display: 'none'
  }
}));

export default useStyles;
